import {Locales} from '@netx/core-next/locales/utils/Locales';

export const CLIPBOARD_TEXT_FIELD_ACTION_LABEL = Locales((i18n) => ({
	COPY: i18n('i18n.copyToClipboard'),
}));

export const CLIPBOARD_TEXT_FIELD_MESSAGE = Locales((i18n) => ({
	ERROR: i18n('i18n.clipboardCopyError'),
	SUCCESS: i18n('i18n.clipboardCopySuccess'),
}));
